import React from 'react';

import ItemPreview from './ItemPreview';
import Gems from '../../Dashboard/images/gem.svg';

const SpecialStore = ({ actions, error, isOpen, items = [], loading, onSelectItem, stockTime, selectedId }) => {
    const stockDigits = `000000${String(stockTime || '').replace(/\D/g, '')}`
        .slice(-6)
        .split('');

    return (
        <div className="special-store">
            {!loading && <div className="special-store__stock">
                <p>Store Stock<br />Available for</p>
                <div className="special-store__timer" aria-label={`Store stock available for ${stockDigits.slice(0, 2).join('')} days, ${stockDigits.slice(2, 4).join('')} hours, ${stockDigits.slice(4, 6).join('')} minutes`}>
                    {stockDigits.map((digit, index) => (
                        <span key={`${index}-${digit}`} aria-hidden="true">{digit}</span>
                    ))}
                </div>
            </div>}
            <div className="store__items special-store__items">
                <h2 className="store__items-title">Special Store</h2>
                {!loading && actions}
                {loading ?
                    <p className="special-store__closed" role="status">Loading special store...</p> :
                    error ?
                        <p className="special-store__closed">Unable to load the special store.</p> :
                        isOpen ?
                            <ul className="store__items-list">
                                {items.map(item => {
                                    const id = item.id || item.xmlId;
                                    const isSelected = id === selectedId;
                                    return <li
                                        key={id}
                                        className={`store__item ${isSelected ? 'store__item--wearing' : ''}`}
                                        onClick={() => onSelectItem(item)}
                                    >
                                        <p className="store__item-name">{item.name || `Special Item ${item.id}`}</p>
                                        <ItemPreview
                                            src={Array.isArray(item.url) ? item.url[0] : item.url}
                                            className="store__item-img"
                                        />
                                        <p className={`store__item-status ${item.owned ? 'store__item-status--owned' : ''}`}>
                                            {item.owned ?
                                                <><span aria-hidden="true">✓</span> Owned</> :
                                                <><img src={Gems} alt="Gems" /> {item.price}</>
                                            }
                                        </p>
                                    </li>
                                }


                                )}
                            </ul> :
                            <p className="special-store__closed">The store is currently closed</p>
                }
            </div>
        </div>
    );
};


export default SpecialStore;
